import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Rating from "@material-ui/lab/Rating";
import TextField from "@material-ui/core/TextField";
import CloseIcon from "@material-ui/icons/Close";
import SendIcon from "@material-ui/icons/Send";
import Button from "@material-ui/core/Button";
import SentimentVeryDissatisfiedIcon from "@material-ui/icons/SentimentVeryDissatisfied";
import SentimentDissatisfiedIcon from "@material-ui/icons/SentimentDissatisfied";
import SentimentSatisfiedIcon from "@material-ui/icons/SentimentSatisfied";
import SentimentSatisfiedAltIcon from "@material-ui/icons/SentimentSatisfiedAltOutlined";
import SentimentVerySatisfiedIcon from "@material-ui/icons/SentimentVerySatisfied";
import instance from "../../store/actions/instance";
import CircularProgress from "@material-ui/core/CircularProgress";
import MuiPhoneNumber from "material-ui-phone-number";

export const customIcons = {
  1: {
    icon: <SentimentVeryDissatisfiedIcon fontSize={"large"} />,
    label: "Very Dissatisfied",
  },
  2: {
    icon: <SentimentDissatisfiedIcon fontSize={"large"} />,
    label: "Dissatisfied",
  },
  3: { icon: <SentimentSatisfiedIcon fontSize={"large"} />, label: "Neutral" },
  4: {
    icon: <SentimentSatisfiedAltIcon fontSize={"large"} />,
    label: "Satisfied",
  },
  5: {
    icon: <SentimentVerySatisfiedIcon fontSize={"large"} />,
    label: "Very Satisfied",
  },
};

export function IconContainer(props) {
  const { value, ...other } = props;
  return <span {...other}>{customIcons[value].icon}</span>;
}
IconContainer.propTypes = {
  value: PropTypes.number.isRequired,
};

class ReviewDrawerContent extends Component {
  state = {
    value: null,
    comment: "",
    commentError: false,
    phoneError: false,
    loading: false,
    name: this.props.customerContact ? this.props.customerContact.name : null,
    phone: this.props.customerContact ? this.props.customerContact.phone : null,
    phoneFieldKey: Math.random() * 99999,
  };

  async createFeedback() {
    this.setState({ loading: true });
    const url = this.props.productID
      ? "/create_product_feedback/"
      : "/create_feedback/";
    const res = await instance.post(url, {
      rating: this.state.value ? this.state.value : null,
      comment: this.state.comment,
      phone_number: this.state.phone,
      name: this.state.name,
      order: this.props.trackingCode,
      productId: this.props.productID,
    });
    this.setState({ loading: false });
    this.props.closeDrawer();
    if (this.props.onSendSuccess) this.props.onSendSuccess();
  }

  handleSend = () => {
    const { settings } = this.props;
    const phoneRequired = settings?.enable_feedback_for_customers_only;

    const isPhoneValid = () => {
      const phone = this.state.phone;
      return phone && phone.replace(/\D/g, "").length > 5;
    };

    const phoneMissing = phoneRequired && !isPhoneValid();
    const commentMissing = !this.props.productID && !this.state.comment;

    if (phoneMissing || commentMissing) {
      this.setState({
        phoneError: phoneMissing,
        commentError: commentMissing,
      });
      return;
    }

    this.createFeedback();
  };

  handleCommentChange = (e) => {
    if (this.state.commentError) this.setState({ commentError: false });
    this.setState({ comment: e.target.value });
  };

  handleNameChange = (e) => {
    this.setState({ name: e.target.value });
  };

  handlePhoneChange = (e, eventPhone) => {
    if (typeof e === "string") {
      if (e.startsWith("+" + eventPhone.dialCode)) {
        this.setState({ phone: e, phoneError: false });
      } else {
        this.setState({ phoneFieldKey: Math.random() * 999999 });
      }
    }
  };

  checkButtonDisabled = () => {
    if (this.props.productID) {
      return !(this.state.value !== null || this.state.comment !== "");
    }
    return false;
  };

  render() {
    const language = this.props.language;
    const countryObj = this.props.countries?.find(
      (c) => c?.id === this.props.address?.country
    );

    return (
      <div>
        <span
          style={{
            position: "absolute",
            top: 15,
            right: language === "english" && 15,
            left: language === "arabic" && 15,
          }}
        >
          <CloseIcon
            onClick={this.props.closeDrawer}
            style={{ color: "#565656" }}
          />
        </span>
        <h2
          className={
            "mx-auto " + (language === "english" ? "text-left" : "text-right")
          }
          style={{
            width: "90%",
            marginTop: 25,
            fontFamily: language === "english" ? "Quicksand" : "Cairo",
          }}
        >
          {this.props.productID
            ? language === "english"
              ? "Leave review"
              : "تقييم"
            : language === "english"
            ? "Leave feedback"
            : "تقييم"}
        </h2>

        <Rating
          name="simple-controlled"
          value={this.state.value}
          onChange={(event, newValue) => this.setState({ value: newValue })}
          classes={{ label: "large-star" }}
          style={{ marginTop: 10 }}
          IconContainerComponent={IconContainer}
          getLabelText={(value) => customIcons[value].label}
        />

        <div
          className="row mx-auto"
          dir={language === "english" ? "ltr" : "rtl"}
          style={{ width: "92%" }}
        >
          <div
            className={"col-6 " + (language === "english" ? "pl-0" : "pr-0")}
          >
            <h4
              className={language === "english" ? "text-left" : "text-right"}
              dir={language === "english" ? "ltr" : "rtl"}
              style={{
                fontFamily: language === "english" ? "Quicksand" : "Cairo",
                marginTop: 10,
                marginBottom: 3,
              }}
            >
              {language === "english" ? "Name" : "الاسم"}
              <span style={{ color: "grey", fontSize: 10 }}>
                ({language === "english" ? "Optional" : "اختياري"})
              </span>
            </h4>
            <TextField
              dir={language === "english" ? "ltr" : "rtl"}
              style={{ width: "100%", marginBottom: 0 }}
              variant="outlined"
              value={this.state.name}
              onChange={this.handleNameChange}
            />
          </div>

          <div
            className={"col-6 " + (language === "english" ? "pr-0" : "pl-0")}
          >
            <h4
              className={language === "english" ? "text-left" : "text-right"}
              dir={language === "english" ? "ltr" : "rtl"}
              style={{
                fontFamily: language === "english" ? "Quicksand" : "Cairo",
                marginTop: 10,
                marginBottom: 3,
              }}
            >
              {language === "english" ? "Phone" : "رقم الهاتف"}
              <span
                style={{
                  color: this.state.phoneError ? "red" : "grey",
                  fontSize: 10,
                }}
              >
                (
                {this.props.settings?.enable_feedback_for_customers_only
                  ? language === "english"
                    ? "Required"
                    : "اجباري"
                  : language === "english"
                  ? "Optional"
                  : "اختياري"}
                )
              </span>
            </h4>
            <MuiPhoneNumber
              variant="outlined"
              defaultCountry={
                countryObj?.dial_code ||
                this.props.store.default_dial_code ||
                "kw"
              }
              onlyCountries={
                this.props.settings.show_all_country_codes
                  ? []
                  : [
                      "kw",
                      "sa",
                      "qa",
                      "om",
                      "ae",
                      "bh",
                      "sy",
                      "lb",
                      "jo",
                      "eg",
                      "us",
                      "uk",
                      "cn",
                    ]
              }
              excludeCountries={["il"]}
              countryCodeEditable={false}
              disableAreaCodes={true}
              onChange={this.handlePhoneChange}
              key={this.state.phoneFieldKey}
              value={this.state.phone}
              fullWidth
              FormHelperTextProps={{
                style: {
                  textAlign: language === "arabic" && "right",
                  marginRight: language === "arabic" && 5,
                },
              }}
              style={{
                borderRadius: 4,
                border: this.state.phoneError ? "1px solid red" : undefined,
              }}
            />
            {this.state.phoneError && (
              <span style={{ color: "red" }}>
                {language === "english"
                  ? "Phone number is required"
                  : "رقم الهاتف اجباري"}
              </span>
            )}
          </div>
        </div>

        <div
          className="row mx-auto"
          dir={language === "english" ? "ltr" : "rtl"}
          style={{ width: "92%" }}
        >
          <h4
            className={language === "english" ? "text-left" : "text-right"}
            dir={language === "english" ? "ltr" : "rtl"}
            style={{
              fontFamily: language === "english" ? "Quicksand" : "Cairo",
              marginTop: 10,
              marginBottom: 3,
            }}
          >
            {language === "english" ? "Leave us a comment" : "اترك لنا تعليق"}
            {this.state.commentError && (
              <span style={{ color: "red" }}>
                {" "}
                {language === "english"
                  ? "- Please enter a comment"
                  : "- الرجاء كتابة تعليق"}
              </span>
            )}
          </h4>
          <TextField
            dir={language === "english" ? "ltr" : "rtl"}
            style={{ width: "100%", marginBottom: 10 }}
            multiline
            variant="outlined"
            error={this.state.commentError}
            onChange={this.handleCommentChange}
          />
        </div>

        <Button
          className="mt-2 mb-1"
          endIcon={
            !this.state.loading && language === "english" && <SendIcon />
          }
          startIcon={
            !this.state.loading &&
            language === "arabic" && <SendIcon className="flip-180" />
          }
          variant="contained"
          color="primary"
          style={{ width: "92%", height: 45 }}
          disableElevation
          disabled={this.checkButtonDisabled()}
          onClick={this.handleSend}
        >
          {this.state.loading ? (
            <CircularProgress
              style={{ color: "white", width: 30, height: 30 }}
            />
          ) : language === "english" ? (
            "Send"
          ) : (
            "ارسال"
          )}
        </Button>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    customerContact: state.customers.customerContact,
    address: state.customers?.address,
    settings: state.store.store.settings,
    store: state.store.store,
    countries: state.store.store.all_countries || state.store.store.countries,
  };
};

export default connect(mapStateToProps)(ReviewDrawerContent);
